const VIEW_ONLY_ROLES = ['accounting_manager', 'accounting_super_manager', 'regional_sales_manager', 'cco', 'ceo'];
const ALL_BRANCHES_ROLES = ['superadmin', 'admin', 'credit_officer', 'accounting_manager', 'accounting_super_manager', 'regional_sales_manager', 'cco', 'ceo'];

export function getCurrentUser() {
    try {
        const user = localStorage.getItem('crs_user');
        return user ? JSON.parse(user) : null;
    } catch {
        return null;
    }
}

export function isViewOnlyRole(role) {
    return VIEW_ONLY_ROLES.includes(role);
}

export function isAllBranchesRole(role) {
    return ALL_BRANCHES_ROLES.includes(role);
}

export function canEditCollectionEntries(role) {
    return !isViewOnlyRole(role);
}

export function getRoleDisplayName(role) {
    const displayNames = {
        'superadmin': 'System Administrator',
        'ar': 'Accounting Representative',
        'as': 'Account Supervisor',
        'asm': 'Area Sales Manager',
        'credit_officer': 'Credit Collection Officer',
        'accounting_manager': 'Accounting Manager',
        'accounting_super_manager': 'Accounting Senior Manager',
        'regional_sales_manager': 'Regional Sales Manager',
        'cco': 'Chief Operating Officer',
        'ceo': 'Chief Executive Officer',
        'user': 'User'
    };
    return displayNames[role] || role?.replace(/_/g, ' ') || 'User';
}
